import { NavigationGuardNext, Route } from 'vue-router';
import { LIST_PERMISSION } from '@/constant/ListPermission';

import Permission from './index';

export function permissionAds(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();
  const showAds = PermissionClass.can(LIST_PERMISSION.ADS);

  if (!showAds) {
    next({
      name: 'Dashboard'
    });
  }

  next();
}
